import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import {
    __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon,
    SelectControl
} from '@wordpress/components';
import {
    arrowRight,arrowDown,arrowLeft,arrowUp,
    justifyLeft,justifyCenter,justifyRight, justifySpaceBetween,
    justifyStretch,justifyTop,justifyCenterVertical,justifyBottom,
    justifySpaceBetweenVertical,justifyStretchVertical,
} from '@wordpress/icons';
import { VayuBlocksDeviceControl,VayuBlocksDevice  } from '@vayu-blocks/device-control';
import { HeightControl } from '@vayu-blocks';

const defaultFlex = {
    direction: { Desktop: '', Tablet: '', Mobile: '' },
    justifyContent: { Desktop: '', Tablet: '', Mobile: '' },
    alignItems: { Desktop: '', Tablet: '', Mobile: '' },
    wrap: { Desktop: '', Tablet: '', Mobile: '' },
    alignContent: { Desktop: '', Tablet: '', Mobile: '' },
    rwGap: { Desktop: 0, Tablet: 0, Mobile: 0 },
    colGap: { Desktop: 0, Tablet: 0, Mobile: 0 },
};

export const VayuBlocksFlex = ({ onChange, flex = {} }) => {
    const getView = VayuBlocksDevice() || 'Desktop';
    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);

    const {
        direction = defaultFlex.direction,
        justifyContent = defaultFlex.justifyContent,
        alignItems = defaultFlex.alignItems,
        wrap = defaultFlex.wrap,
        alignContent = defaultFlex.alignContent,
        rwGap = defaultFlex.rwGap,
        colGap = defaultFlex.colGap,
    } = flex?.value || {};

    const getDirection = () => direction?.[getView];
    const getJustify = () => justifyContent?.[getView];
    const getAlignItem = () => alignItems?.[getView];
    const getWrap = () => wrap?.[getView];
    const getAlignContent = () => alignContent?.[getView];
    const getrwGap = () => rwGap?.[getView];
    const getcolGap = () => colGap?.[getView];

    const updateFlexValue = (keyName, newVal) => {
        const updatedAttributes = {
            ...flex.value,
            [keyName]: {
                ...flex.value?.[keyName],
                [getView]: newVal,
            },
        };

        const isFirstRun = flex.value?.[keyName]?.[getView] === undefined;
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (getView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
               Object.assign(updatedAttributes[keyName], {
                Tablet: newVal, Mobile: keyName === 'direction' ? 'column' : newVal });
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (getView === 'Tablet') {
            if (isTabletFirstRun) {
                Object.assign(updatedAttributes[keyName], { 
                Mobile: keyName === 'direction' ? 'column' : newVal });
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else if (getView === 'Mobile' && keyName === 'direction') {
        // Force direction to 'column' on Mobile regardless of input
        // updatedAttributes[keyName][getView] = 'column';
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

        onChange(flex.key, updatedAttributes);
    };

    const justifyOptions = direction[getView] === 'row' ? [
        { icon: justifyLeft, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenter, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyRight, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifySpaceBetween, label: __('space-between', 'vayu-blocks'), value: 'space-between' },
        { icon: justifyStretch, label: __('space-around', 'vayu-blocks'), value: 'space-around' },
    ] : direction[getView] === 'row-reverse' ? [
        { icon: justifyRight, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenter, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyLeft, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifySpaceBetween, label: __('space-between', 'vayu-blocks'), value: 'space-between' },
        { icon: justifyStretch, label: __('space-around', 'vayu-blocks'), value: 'space-around' },
    ] : direction[getView] === 'column-reverse' ? [
        { icon: justifyBottom, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenterVertical, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyTop, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifySpaceBetweenVertical, label: __('space-between', 'vayu-blocks'), value: 'space-between' },
        { icon: justifyStretchVertical, label: __('space-around', 'vayu-blocks'), value: 'space-around' },
    ] : [
        { icon: justifyTop, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenterVertical, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyBottom, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifySpaceBetweenVertical, label: __('space-between', 'vayu-blocks'), value: 'space-between' },
        { icon: justifyStretchVertical, label: __('space-around', 'vayu-blocks'), value: 'space-around' },
    ];

    const alignItemOptions = (direction[getView] === 'row' || direction[getView] === 'row-reverse') ? [
        { icon: justifyTop, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenterVertical, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyBottom, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifyStretchVertical, label: __('stretch', 'vayu-blocks'), value: 'stretch' },
    ] : [
        { icon: justifyLeft, label: __('start', 'vayu-blocks'), value: 'flex-start' },
        { icon: justifyCenter, label: __('center', 'vayu-blocks'), value: 'center' },
        { icon: justifyRight, label: __('end', 'vayu-blocks'), value: 'flex-end' },
        { icon: justifyStretch, label: __('stretch', 'vayu-blocks'), value: 'stretch' },
    ];

    return (
        <>

            <span> {<VayuBlocksDeviceControl label={__('Flex', 'vayu-blocks')} classname='bold'/>}</span>

            {/* Direction */}
            <div className="vb-toogle-icon-position alignment-component-vb">
                <ToggleGroupControl
                    label={ __( 'Direction', 'vayu-blocks' ) }
                    __next40pxDefaultSize={true}
                    value={getDirection()}
                    className="vb-toogle-icon-position-border"
                    onChange={(value) => updateFlexValue('direction', value)}
                    isDeselectable
                >
                    <ToggleGroupControlOptionIcon
                        icon={arrowRight}
                        label={__('row-horizontal', 'vayu-blocks')}
                        value="row"
                    />
                    <ToggleGroupControlOptionIcon
                        icon={arrowDown}
                        label={__('column-vertical', 'vayu-blocks')}
                        value="column"
                    />
                    <ToggleGroupControlOptionIcon
                        icon={arrowLeft}
                        label={__('row-reversed', 'vayu-blocks')}
                        value="row-reverse"
                    />
                    <ToggleGroupControlOptionIcon
                        icon={arrowUp}
                        label={__('column-reversed', 'vayu-blocks')}
                        value="column-reverse"
                    />
                </ToggleGroupControl>
            
            </div>
            
            {/* Justify Content */}
           <div className="vb-toogle-icon-position alignment-component-vb">
                <ToggleGroupControl
                    label={ __( 'Justify Content', 'vayu-blocks' ) }
                    __next40pxDefaultSize={true}
                    isDeselectable
                    className="vb-toogle-icon-position-border"
                    value={getJustify()}
                    onChange={(value) => updateFlexValue('justifyContent', value)}
                >
                    {justifyOptions.map((option, index) => (
                        <ToggleGroupControlOptionIcon
                            key={index}
                            icon={option.icon}
                            label={option.label}
                            value={option.value}
                        />
                    ))}
                </ToggleGroupControl>
            </div>

            {/* Align Items */}
            <div className="vb-toogle-icon-position alignment-component-vb">
                
                    <ToggleGroupControl
                       label={__('AlignItem', 'vayu-blocks')}
                       __next40pxDefaultSize={true}
                       isDeselectable
                        value={getAlignItem()}
                         className="vb-toogle-icon-position-border"
                        onChange={(value) => updateFlexValue('alignItems', value)}
                    >
                       {alignItemOptions.map((option, index) => (
                        <ToggleGroupControlOptionIcon
                            key={index}
                            icon={option.icon}
                            label={option.label}
                            value={option.value}
                        />
                    ))}
                    </ToggleGroupControl>
                
            </div>

            {/* Wrap */}
            <div className="vb-toogle-icon-position alignment-component-vb">
                
                    <ToggleGroupControl
                        label={__('Wrap', 'vayu-blocks')}
                        __next40pxDefaultSize={true}
                        isDeselectable
                        value={getWrap()}
                         className="vb-toogle-icon-position-border"
                        onChange={(value) => updateFlexValue('wrap', value)}
                    >
                        <ToggleGroupControlOptionIcon
                            icon={justifyLeft}
                            label={__('no-wrap', 'vayu-blocks')}
                            value="nowrap"
                        />
                        <ToggleGroupControlOptionIcon
                            icon={justifyRight}
                            label={__('wrap', 'vayu-blocks')}
                            value="wrap"
                        />
                    </ToggleGroupControl>
                
            </div>

            {/* Align Content */}
            {getWrap() === 'wrap' && (
                <div className="vb-toogle-icon-position alignment-component-vb wrap-select vb-selectcontrol-flex">
                    <SelectControl
                        label={__('Align Content', 'vayu-blocks')}
                        value={getAlignContent()}
                        onChange={(value) => updateFlexValue('alignContent', value)}
                        options={[
                            { label: __('Default', 'vayu-blocks'), value: 'default' },
                            { label: __('Center', 'vayu-blocks'), value: 'center' },
                            { label: __('Flex-Start', 'vayu-blocks'), value: 'flex-start' },
                            { label: __('Flex-End', 'vayu-blocks'), value: 'flex-end' },
                            { label: __('Space-Between', 'vayu-blocks'), value: 'space-between' },
                            { label: __('Space-Around', 'vayu-blocks'), value: 'space-around' },
                            { label: __('Space-Evenly', 'vayu-blocks'), value: 'space-evenly' },
                        ]}
                    />
                </div>
            )}

            {/* Gap between elements */}
            <HeightControl 
                label={__('Row Gap', 'vayu-blocks')}
                onChange={(value) => updateFlexValue('rwGap', value)}
                value={getrwGap()}
            />

            <br/>

            <HeightControl 
                label={__('Column Gap', 'vayu-blocks')}
                onChange={(value) => updateFlexValue('colGap', value)}
                value={getcolGap()}
            />
        </>
    );
};